import { persistentWritable } from './persistentStore'

export const lastKnownVersionId = persistentWritable('tailorVLastKnownVersionId', null)
export default lastKnownVersionId
